// Utility functions for converting prospect data formats

import { type Prospect } from '../components/ProspectPanel';

interface UseCaseMeta {
  use_case_id: number;
  name: string;
  use_case_abr?: string;
  status: string;
}

/**
 * Convert useProspectList format to ProspectPanel format
 */
export function convertToProspectPanelFormat(rawProspects: UseCaseMeta[]): Prospect[] {
  return rawProspects.map((uc) => {
    // Check if name is a placeholder
    const isPlaceholderName = !uc.name || uc.name.match(/^Use Case \d+$/);
    
    // Abbreviation: ONLY use use_case_abr if it exists and is different from name
    // Don't create abbreviation from name - only show pill if we have real abbreviation
    const abbreviation = uc.use_case_abr && uc.use_case_abr.trim() !== '' && uc.use_case_abr !== uc.name
      ? uc.use_case_abr
      : null;
    
    // Full name: use actual name if available, otherwise use abbreviation, never "Use Case XX"
    const fullName = uc.name && !isPlaceholderName
      ? uc.name
      : (uc.use_case_abr || `Use Case ${uc.use_case_id}`);
    
    // Log warning if we're using placeholder
    if (isPlaceholderName && !uc.use_case_abr) {
      console.warn(`⚠️ [prospectUtils] Use case ${uc.use_case_id} missing both name and abbreviation!`, {
        use_case_id: uc.use_case_id,
        name: uc.name,
        use_case_abr: uc.use_case_abr
      });
    }
    
    return {
      id: String(uc.use_case_id),
      abbreviation: abbreviation || '', // Empty string if no real abbreviation
      fullName,
      status: (uc.status === 'prospect' ? 'Prospect' : 
               uc.status === 'qualified' ? 'Qualified' :
               uc.status === 'roadmapping' ? 'Roadmapping' :
               uc.status === 'approval' ? 'Approval' :
               uc.status === 'execution' ? 'Execution' : 'Prospect') as Prospect['status']
    };
  });
}

